import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-dpottery',
  templateUrl: './program-dpottery.component.html',
  styleUrls: ['./program-dpottery.component.scss']
})
export class ProgramDpotteryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
